import axiosInstance from '@/plugins/axios'
import { appApiUrls } from '../constants/apiUrls'

/**
 * Fetches all custom reimbursement types configured for the organization
 * (e.g., Phone, Internet, Travel, Miscellaneous, etc.)
 */
export const getCustomReimbursements = (params = {}) => {
  return axiosInstance.get(appApiUrls.claim.customReimbursements, { params })
}

/**
 * Fetches claims/reimbursements for a specific user
 * @param {string} userId - User Object ID
 * @param {object} params - { year, reimbursementType }
 */
export const getUserReimbursements = (userId, params = {}) => {
  return axiosInstance.get(`${appApiUrls.claim.userReimbursements}/${userId}`, { params })
}

/**
 * Uploads a receipt / invoice document
 * @param {FormData} formData - Contains { attachments, userId, month }
 */
export const uploadReimbursementDocument = (formData) => {
  return axiosInstance.post(appApiUrls.claim.uploadDocument, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

/**
 * Submits a new reimbursement claim
 * @param {object} payload - Claim payload
 */
export const submitReimbursement = (payload) => {
  return axiosInstance.post(appApiUrls.claim.submitReimbursement, payload)
}

/**
 * Updates / Resubmits an existing reimbursement claim
 * @param {string} id - Claim ID
 * @param {object} payload - Updated claim payload
 */
export const updateReimbursement = (id, payload) => {
  return axiosInstance.put(`${appApiUrls.claim.updateReimbursement}/${id}`, payload)
}
